import Button from '@/components/UI/Button';
import Checkbox from '@/components/UI/Checkbox';
import Image from '@/components/UI/Image';
import Select from '@/components/UI/Select';
import EFAcInput from '@/components/UI/svg/Icons/EFAcInput';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import EFCarInput from '@/components/UI/svg/Icons/EFCarInput';
import EFSolarInput from '@/components/UI/svg/Icons/EFSolarInput';
import { specGeneralKeyMap, specGroupGeneralKeyMap } from '@/config/generalKeyMap';
import { productCatagory, queryComparisonProductInfo } from '@/service';
import { handleMultiProductImages } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { message } from 'antd';
import css from './index.module.scss';
const specGroupSort = Object.keys(specGroupGeneralKeyMap);
let isHideDupli = false;
const emptyValueTxt = '–';

export default function CompareList({ selectList, productCatagoryId, lang }: any) {
    const { Link, useEffect, useState, useRouter, useRef, useLang, gloproductlist, gtm, isMobile } = useGlobal();

    const router = useRouter();
    const { locale, query } = useRouter();
    const selectRef = useRef();
    const [selected, setSelected] = useState([]); // 初始化选中id
    const [spkuListData, setSpkuListData] = useState([]);
    const [arrList, setArrList] = useState([]);
    const [productCategory, setProductCategory] = useState([]);
    const [productContent, setProductContent] = useState({ data: [], details: [] });
    const [lastChangeNum, setLastChangeNum] = useState(-1);
    const { t } = useLang('compareseries');

    //滚动吸顶
    const handleScroll = () => {
        //定义handleScroll事件函数
        const header = document.getElementById('compareNav');
        const hideLeft = document.getElementById('filter-box');
        if (window.pageYOffset > 345) {
            header?.classList.add('header--sticky');
            hideLeft?.classList.add('hide--sticky');
        }
        if (window.pageYOffset <= 345 || window.pageYOffset === 0) {
            //否则就移除样式
            header?.classList.remove('header--sticky');
            hideLeft?.classList.remove('hide--sticky');
        }
    };
    //跳转产品详情
    const goProductDetail = (spuId: any, name: string) => {
        const seo = gloproductlist?.find((item: any) => item.type === 'PRODUCT' && item.spuId === spuId);
        gtm.push({
            event: 'uaEvent',
            event_name: 'select_product',
            list_name: 'Compare',
            product_name: name,
            button_name: 'learn_more',
        });

        if (seo.url) {
            const url = ['river-2-pro-portable-power-station', 'river-2-max-portable-power-station'].includes(seo.url)
                ? 'river-2-portable-power-station'
                : seo.url;
            router.push(`/${locale}/${url}`);
        } else {
            router.push(`/${locale}/${seo?.url || ''}`);
        }
    };

    //品类参数
    const getProductCategory = async () => {
        try {
            const res: any = await productCatagory({ productCatagoryId });
            if (res.code === '0') {
                return res.data;
            } else {
                message.error(res.message);
            }
        } catch (e) {
            console.log('e', e);
        }
    };

    //初始化数据
    const initProductData = (item: any, productCategoryData: any) => {
        const selectedData: string[] = [],
            arr: object[] = [];
        item?.arr?.map((list: any) => {
            selectedData.push(list.key);
            arr.push({
                spuId: list.spuId,
                skuId: list.skuId ? list.skuId : '',
                type: list.skuId ? 'SKU' : 'SPU',
            });
        });
        if (!isMobile) {
            setArrList(arr.slice(0, 3));
            getQueryComparisonProductInfo(arr.slice(0, 3), -1, productCategoryData);
            setSelected(selectedData.slice(0, 3));
        } else {
            setArrList(arr.slice(0, 2));
            getQueryComparisonProductInfo(arr.slice(0, 2), -1, productCategoryData);
            setSelected(selectedData.slice(0, 2));
        }
    };
    //显示隐藏
    const handleHideDupli = (e: any) => {
        isHideDupli = e.target.checked;
        getQueryComparisonProductInfo(arrList, lastChangeNum, productCategory, e.target.checked);
    };
    /**
     * 将spec参数组name，与产品的spec参数value，融合到一起
     * @param productCatagoryList 产品品类及spec name 的列表
     * @param skuList spu spec value
     */
    const formatProductSpecData = (productCatagoryList: any[], skuList: any) => {
        if (!skuList || !skuList.length) return [];

        /**
         * 1、将genericSpec， ownSpec字符串解析成对象（此时，对象中的值仍为json字符串）
         * 2、将genericSpec， ownSpec合并到skuSpec
         */
        const formatSkuList = skuList.map((sku: any) => {
            let { ownSpec, ...others } = sku;
            ownSpec = JSON.parse(ownSpec || '{}');
            return { ...others, skuSpec: ownSpec };
        });

        /**
         * 参数组列表初次合并（此时仅有参数名，没有value值）
         */
        let specGroupList: any[] = [];
        productCatagoryList.forEach((productCatagory) => {
            const { specGroupList: currentSpecGroupList } = productCatagory;
            if (!currentSpecGroupList) return;
            specGroupList = [...specGroupList, ...currentSpecGroupList];
        });

        /**
         * 1、遍历产品品类的specGroupList
         * 2、内层遍历spu经过合并的参数组，并且生成一个specList，合入每一个specGroup中
         */
        specGroupList = specGroupList
            ?.map((specGroup: any) => {
                const { specParamList, ...rst } = specGroup;
                let specList: any[] = []; // 参数列表

                const { specGroupId } = specGroup;

                const skusCount: number = formatSkuList.length;
                formatSkuList.forEach((formatSku: any, index: number) => {
                    const { skuSpec } = formatSku;
                    const specGroupJson = skuSpec[specGroupId];
                    if (!specGroupJson) return;
                    let specGroup: any; // 解析单个Group的JSON数据
                    try {
                        specGroup = JSON.parse(specGroupJson || '{}');
                    } catch {
                        specGroup = specGroupJson;
                    }
                    Object.keys(specGroup).forEach((specParamId: string) => {
                        const categorySpecParam = specParamList.find((categorySpecParam: any) => categorySpecParam.specParamId === specParamId);
                        if (!categorySpecParam) return;

                        // 处理boolen值，转换为 Yes or No
                        let specValue: string;
                        if (categorySpecParam.fieldType === 'boolean' || typeof specGroup[specParamId] === 'boolean') {
                            specValue = specGroup[specParamId] ? '✓' : emptyValueTxt;
                            if (specGroup[specParamId] === 'false') {
                                specValue = emptyValueTxt;
                            }
                        } else {
                            specValue = specGroup[specParamId] || emptyValueTxt;
                        }
                        const specItem = specList.find((spec) => spec.specParamId === specParamId);
                        if (!specItem) {
                            // 处理单位
                            if (!Number.isNaN(Number(specValue))) {
                                specValue = specValue + (categorySpecParam.unit || '');
                            }
                            const defaultSpecValueList = new Array(skusCount).fill(emptyValueTxt);
                            defaultSpecValueList[index] = specValue;

                            specList.push({
                                key: categorySpecParam.name,
                                generalKey: categorySpecParam.generalKey,
                                styleJson: categorySpecParam.styleJson,
                                unit: categorySpecParam.unit,
                                value: defaultSpecValueList,
                                sort: categorySpecParam?.sort,
                                specParamId,
                            });
                            return;
                        }
                        // 处理单位
                        if (!Number.isNaN(Number(specValue))) {
                            specValue = specValue + (specItem.unit || '');
                        }
                        specItem.value[index] = specValue;
                    });
                });

                // 排序 ?
                specList = specList.sort((a: any, b: any) => (a.sort || Infinity) - (b.sort || Infinity));
                return { ...rst, arrayList: specList };
            })
            ?.filter((specGroup: any) => !!specGroup.arrayList.length); // 过滤掉arrayList没有值的数据
        /**
         * 根据generalKey将两个品类的规格组以及规格参数名，value值合并
         * 两个品类的相同名字的规格组generalKey不一样...，暂时根据key判断
         */
        const mergerdSpecGroupList: any = [];
        specGroupList.forEach((specGroup) => {
            const mergerdSpecGroup = mergerdSpecGroupList.find((mergerdSpecGroup: any) => mergerdSpecGroup.name === specGroup.name);
            // 如果合并参数组没有该项，直接push进去
            if (!mergerdSpecGroup) {
                mergerdSpecGroupList.push(specGroup);
                return;
            }

            // 如果有，需要遍历待加入的子参数列表，一一push或合并到规格组的specParamList里面
            specGroup?.arrayList?.forEach((specParam: any) => {
                mergerdSpecGroup.arrayList = mergerdSpecGroup.arrayList || []; // 防止没有参数列表
                const mergerdSpecParamList = mergerdSpecGroup.arrayList;

                const mergerdSpec = mergerdSpecParamList.find((mergerdSpec: any) => specParam.key === mergerdSpec.key);

                // 如果合并参数列表没有该项，直接push进去
                if (!mergerdSpec) {
                    mergerdSpecParamList.push(specParam);
                    return;
                }

                // 如果有，合并value
                mergerdSpec.value = mergerdSpec.value.map((str: string, index: number) => {
                    return str !== emptyValueTxt ? str : specParam.value[index];
                });
            });
        });

        // 排序
        return mergerdSpecGroupList.sort((a: any, b: any) => {
            const sortIndexA = specGroupSort.findIndex((key: any) => specGroupGeneralKeyMap[key] === a.generalKey);
            const sortIndexB = specGroupSort.findIndex((key: any) => specGroupGeneralKeyMap[key] === b.generalKey);
            if (sortIndexA == -1 || sortIndexB === -1) return 0;
            return sortIndexA - sortIndexB;
        });
    };

    /**
     * 根据hideDupli去掉重复参数，并删除无数据的选项
     * @param specGroupList
     * @param hideDupli
     */
    const uniqueSpecParams = (specGroupList: any[], hideDupli: boolean) => {
        if (!hideDupli) return specGroupList;

        return specGroupList
            .map((specGroup) => {
                const arrayList = specGroup.arrayList.filter((specParam: any) => {
                    const isAllEqual = specParam.value.every((val: string) => val === specParam.value[0]);
                    return !isAllEqual;
                });
                return { ...specGroup, arrayList };
            })
            ?.filter((specGroup: any) => specGroup.arrayList.length); // 再次过滤掉arrayList没有值的数据
    };

    const getQueryComparisonProductInfo = async (arr: any, num = -1, productCategoryData: object[], hideDupli = false) => {
        const res: any = await queryComparisonProductInfo({ comparisonProductList: arr });
        if (res.code !== '0') {
            message.error(res.message);
            return;
        }
        const selectProductList = res.data?.map((selectProductItem: any) => {
            return {
                ...selectProductItem,
                images: handleMultiProductImages(selectProductItem.images),
            };
        });
        // 参数格式化，合并
        let formatComparisonData = formatProductSpecData(productCategoryData, selectProductList) || [];
        // 根据hideDupli去重
        formatComparisonData = uniqueSpecParams(formatComparisonData, hideDupli);

        setProductContent({ data: selectProductList, details: formatComparisonData });
        gtm.push({
            event: 'uaEvent',
            event_name: 'compare_products',
            product_name: selectProductList[num]?.name || '',
            position: num + 1,
            compare_name: `${selectProductList.map((v: any) => v.name).join('_')}`,
        });
    };

    // 切换对比的产品时
    const updateSelected = async (i: number, val: string) => {
        const element = document.body,
            arr: object[] = [];
        element.style.overflow = 'overlay';
        setLastChangeNum(i);
        const selectedNew = [...selected];
        selectedNew[i] = val || '';
        selectedNew?.map((list: any) => {
            spkuListData.map((item: any) => {
                const onlyKey = item.skuId ? item.skuId : item.spuId;
                if (onlyKey == list) {
                    arr.push({
                        productCatagoryId: item.productCatagoryId,
                        spuId: item.spuId,
                        skuId: item.skuId ? item.skuId : '',
                        type: item.skuId ? 'SKU' : 'SPU',
                    });
                }
            });
        });
        setSelected(selectedNew);
        setArrList(arr);
        getQueryComparisonProductInfo(arr, i, productCategory, isHideDupli);
    };

    // 金额格式化
    const fmtPrice = (price: any) => String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    useEffect(() => {
        window.addEventListener('resize', () => {});
    }, [selectRef]);

    useEffect(() => {
        const selectListLen = selectList.length;
        const dell = async () => {
            window.addEventListener('scroll', handleScroll);
            const productCategoryData = await getProductCategory(); // 获取参数组
            setProductCategory(productCategoryData);

            if (selectListLen > 0) {
                const spkuListData: object[] = [];
                //下拉列表
                if (query.series == 'delta' || query.series == 'river' || query.series == 'solar') {
                    selectList?.map((item: any) => {
                        item?.arr?.map((list: any) => {
                            spkuListData.push(list);
                        });
                        setSpkuListData(spkuListData);
                        if (query.series == 'delta' && item.generalKey == 'product_ps_delta') {
                            initProductData(item, productCategoryData);
                        }
                        if (query.series == 'river' && item.generalKey == 'product_ps_river') {
                            initProductData(item, productCategoryData);
                        }
                        if (query.series == 'solar' && item.generalKey == 'product_sp') {
                            initProductData(item, productCategoryData);
                        }
                    });
                }
            }
        };
        dell();
    }, [selectList.length]); // 监听产品系列变化

    return (
        <div className={`${css.comparelist}`}>
            <div className="container clearfix">
                <div className="list">
                    <div id="compareNav">
                        <div className="select-list-box container">
                            {selected?.map((ele: any, idx: number) => (
                                <div className={selected.length > 2 ? 'select-list-item' : 'select-list-item two-list-item'} key={ele + String(idx)}>
                                    <Select
                                        refs={selectRef}
                                        defaultValue={selected[idx]}
                                        className={
                                            isMobile
                                                ? 'default-select rounds middle-select font-family-medium compareh5'
                                                : 'default-select rounds middle-select font-family-medium'
                                        }
                                        placeholder="Select..."
                                        data={selectList}
                                        selType={'optGroup'}
                                        haveSelect={selected}
                                        virtual={isMobile ? false : true}
                                        dropdownClassName={`${css.compareDropdown} compareDropdown`}
                                        onChange={(val: any) => updateSelected(idx, val)}
                                        getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                        dropdownStyle={{
                                            maxHeight: isMobile ? '3.52rem' : 'auto',
                                            overflow: 'auto',
                                        }}
                                        onMouseEnter={(e: any) => {
                                            if (isMobile) {
                                                const element = document.body;
                                                element.style.overflow = 'hidden';
                                            }
                                        }}
                                        onMouseLeave={(e: any) => {
                                            const element = document.body;
                                            element.style.overflow = '';
                                        }}
                                        suffixIcon={
                                            <span
                                                style={{
                                                    display: 'block',
                                                    transform: 'rotate(0deg)',
                                                }}
                                            >
                                                <EFArrowDown style={{ fontSize: '12px' }} />
                                            </span>
                                        }
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="filter-box hide-sticky fadeIn" id="filter-box">
                        <Checkbox className="default-checkbox checkbox-container" onChange={(e: any) => handleHideDupli(e)}>
                            <span className="font-family-regular">{lang.hide_duplicated}</span>
                        </Checkbox>
                    </div>
                </div>
                <div className="list product-list">
                    <div className="select-list-box">
                        {productContent?.data?.map((item: any, index: number) =>
                            item !== '' ? (
                                <div className="select-list-item" key={item?.generalKey + index}>
                                    <div className="item-box">
                                        {item.skuId && (
                                            <span className="imgs">
                                                <Image
                                                    src={item?.images ? item.images : '/img/logo.png'}
                                                    width={isMobile ? 80 : 134}
                                                    height={isMobile ? 80 : 134}
                                                    alt={item?.name}
                                                />
                                            </span>
                                        )}
                                        {!item.skuId && (
                                            <span className="imgs">
                                                <Image
                                                    src={item?.images ? item.images : '/img/logo.png'}
                                                    width={isMobile ? 120 : 200}
                                                    height={isMobile ? 120 : 200}
                                                    alt={item?.name}
                                                />
                                            </span>
                                        )}
                                        <h4 className="price font-family-semibold">
                                            {item?.unit}
                                            {locale === 'jp' ? fmtPrice(item?.price) : item?.price}
                                        </h4>
                                        <p>
                                            <Link
                                                href={item?.buyLink ? item.buyLink : '/'}
                                                ariaLabel={item?.buyLink ? t('buyName') : t('EcoFlow')}
                                                dataLayer={{
                                                    event: 'uaEvent',
                                                    event_name: 'buy',
                                                    product_name: item.name,
                                                    position: `Compare_${index + 1}`,
                                                }}
                                            >
                                                <Button
                                                    type="primary"
                                                    className="default-btn round black-btn msmall buy font-family-regular"
                                                    ariaLabel={item?.name}
                                                >
                                                    {lang.buyName}
                                                </Button>
                                            </Link>
                                        </p>
                                        <p>
                                            <Button
                                                type="link"
                                                className="link-btn font-family-regular"
                                                onClick={() => goProductDetail(item?.spuId, item?.name)}
                                                ariaLabel={item?.name}
                                            >
                                                {lang.moreName}
                                                <span
                                                    className="imgs"
                                                    style={{
                                                        display: 'inline-block',
                                                        height: 'auto',
                                                        marginLeft: '4px',
                                                        transform: isMobile ? '' : 'rotate(-90deg)',
                                                    }}
                                                >
                                                    <EFArrowDown
                                                        style={{
                                                            fontSize: isMobile ? '11px' : '12px',
                                                            color: isMobile ? '#2673ff' : '#000',
                                                        }}
                                                    />
                                                </span>
                                            </Button>
                                        </p>
                                    </div>
                                </div>
                            ) : (
                                <div className="select-list-item" key={item?.generalKey + Math.random()}></div>
                            ),
                        )}
                    </div>
                    <div className={!isMobile ? 'jp-desc' : 'jp-desc mobile-desc'}>*表示価格はすべて税込みです。</div>
                </div>
                {productContent?.details?.map((item: any, i: any) =>
                    item?.arrayList.length == 1 &&
                    item?.arrayList[0]?.generalKey.toLowerCase() == "what's in the box" &&
                    item?.arrayList[0].value.every((valItem: any) => valItem == '–') ? (
                        ''
                    ) : (
                        <div className="detail-list" key={item.specGroupId + i}>
                            <h2 className="detail-title font-family-bold">
                                <span>{item.name}</span>
                            </h2>
                            <div
                                className={`detail-item
                                ${item.generalKey === specGroupGeneralKeyMap['spec_group_quick_look'] ? 'detail-item-look' : ''}
                                ${selected.length > 2 ? '' : 'two-item'}`}
                            >
                                {item?.arrayList?.map((list: any) => (
                                    <ul key={list.specParamId + Math.random()}>
                                        {list.value.length > 0 &&
                                            list.value.map((specVal: any, idx: number) => {
                                                const specFlag = locale === 'sa' && String(specVal).indexOf('[* *]') > -1;
                                                const spec = specFlag ? specVal.replace('[* *]', '') : specVal;
                                                return (
                                                    <li key={list.specParamId + idx}>
                                                        <div className={`content ${specFlag ? 'ltr' : ''}`}>
                                                            {selected[idx] !== '' && (
                                                                <>
                                                                    {item.generalKey.toLowerCase() !== specGroupGeneralKeyMap['spec_group_what_in_the_box'] &&
                                                                        item.generalKey != specGroupGeneralKeyMap['spec_group_quick_look'] && (
                                                                            <h4 className="case-text1 font-family-semibold">{list.key}</h4>
                                                                        )}
                                                                    {item.generalKey != specGroupGeneralKeyMap['spec_group_input'] &&
                                                                        item.generalKey.toLowerCase() !==
                                                                            specGroupGeneralKeyMap['spec_group_what_in_the_box'] &&
                                                                        item.generalKey !== specGroupGeneralKeyMap['spec_group_quick_look'] && (
                                                                            <h4 style={{ marginTop: '2px' }} className="small ">
                                                                                {typeof spec == 'string' || typeof spec == 'number' ? spec : '-'}
                                                                            </h4>
                                                                        )}
                                                                    {item.generalKey.toLowerCase() === specGroupGeneralKeyMap['spec_group_what_in_the_box'] && (
                                                                        <h4
                                                                            style={{
                                                                                lineHeight: isMobile ? '.24rem' : '36px',
                                                                                marginTop: isMobile ? 0 : '2px',
                                                                                whiteSpace: isMobile ? 'inherit' : 'pre-wrap',
                                                                                wordBreak: 'break-word',
                                                                            }}
                                                                            className="small font-family-medium"
                                                                        >
                                                                            {typeof spec == 'string' ? spec : '-'}
                                                                        </h4>
                                                                    )}
                                                                    {item.generalKey == specGroupGeneralKeyMap['spec_group_input'] && (
                                                                        <h4 className="case-text1 last-text qq">
                                                                            <span className="inputs">
                                                                                {list.generalKey == specGeneralKeyMap['specs_ac_charging'] ? (
                                                                                    <EFAcInput />
                                                                                ) : list.generalKey == specGeneralKeyMap['specs_solar_charging'] ? (
                                                                                    <EFSolarInput />
                                                                                ) : list.generalKey == specGeneralKeyMap['specs_car_charging'] ? (
                                                                                    <EFCarInput />
                                                                                ) : (
                                                                                    <EFAcInput />
                                                                                )}
                                                                            </span>
                                                                            <b className="small font-family-regular">
                                                                                {typeof spec == 'string' || typeof spec == 'number' ? spec : '-'}
                                                                            </b>
                                                                        </h4>
                                                                    )}
                                                                    {item.generalKey == specGroupGeneralKeyMap['spec_group_quick_look'] &&
                                                                        list.styleJson?.firstType != 'icon' && (
                                                                            <>
                                                                                <h4
                                                                                    className={
                                                                                        list.styleJson?.firstType == 'large'
                                                                                            ? 'large font-family-semibold qlast-text'
                                                                                            : list.styleJson?.firstType == 'medium'
                                                                                            ? 'medium font-family-semibold qlast-text'
                                                                                            : list.styleJson?.firstType == 'small'
                                                                                            ? 'small font-family-semibold qlast-text'
                                                                                            : 'large font-family-semibold qlast-text'
                                                                                    }
                                                                                >
                                                                                    {typeof spec == 'string' || typeof spec == 'number' ? spec : '-'}
                                                                                </h4>
                                                                                <h4 className="case-text1 quick-text font-family-semibold">{list.key}</h4>
                                                                            </>
                                                                        )}
                                                                    {item.generalKey == specGroupGeneralKeyMap['spec_group_quick_look'] &&
                                                                        list.styleJson?.firstType == 'icon' &&
                                                                        list.styleJson?.secondType != 'icon' && (
                                                                            <>
                                                                                {list.generalKey == specGeneralKeyMap['specs_mobile_app'] && (
                                                                                    <span className="apps qlast-text">
                                                                                        <Image src={list.styleJson.firstIcon} layout="fill" alt={list.key} />
                                                                                    </span>
                                                                                )}
                                                                                {list.generalKey != specGeneralKeyMap['specs_mobile_app'] && (
                                                                                    <span className="apps apps-18 qlast-text">
                                                                                        <Image src={list.styleJson.firstIcon} layout="fill" alt={spec} />
                                                                                    </span>
                                                                                )}
                                                                                <h4 className="case-text1 quick-text font-family-semibold">{list.key}</h4>
                                                                                {spec != '' && (
                                                                                    <h4
                                                                                        className={
                                                                                            list.styleJson?.secondType == 'large'
                                                                                                ? 'large font-family-semibold qlast-tex'
                                                                                                : list.styleJson?.secondType == 'medium'
                                                                                                ? 'medium font-family-semibold qlast-tex'
                                                                                                : list.styleJson?.secondType == 'small'
                                                                                                ? 'small quick-text font-family-semibold qlast-tex'
                                                                                                : 'small quick-text font-family-semibold qlast-tex'
                                                                                        }
                                                                                    >
                                                                                        {list.generalKey != specGeneralKeyMap['specs_mobile_app'] ? spec : ''}
                                                                                    </h4>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    {item.generalKey == specGroupGeneralKeyMap['spec_group_quick_look'] &&
                                                                        list.styleJson?.firstType != 'icon' &&
                                                                        list.styleJson?.secondType == 'icon' && (
                                                                            <>
                                                                                <span className="apps apps-18 qlast-text">
                                                                                    <Image
                                                                                        src={list.styleJson.secondIcon}
                                                                                        layout="fill"
                                                                                        className="fullImgs"
                                                                                        alt={list.key}
                                                                                    />
                                                                                </span>
                                                                            </>
                                                                        )}
                                                                </>
                                                            )}
                                                        </div>
                                                    </li>
                                                );
                                            })}
                                    </ul>
                                ))}
                            </div>
                        </div>
                    ),
                )}
            </div>
        </div>
    );
}
